import React from 'react'
import { Image } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './People.css'

import people01 from '@brainstud/react-tbl/themes/pgw/v1/assets/img/people-asm.svg'
import people02 from '@brainstud/react-tbl/themes/pgw/v1/assets/img/people-plus.svg'
import people03 from '@brainstud/react-tbl/themes/pgw/v1/assets/img/people-mc.svg'
import people04 from '@brainstud/react-tbl/themes/pgw/v1/assets/img/people-procurement.svg'

const PeopleGroup = props => {
  const classNames = ['People']

  if(props.faded) classNames.push('is-faded')
  if(props.large) classNames.push('is-large')

  return (
    <div className={classNames.join(' ')}>
      {props.children}
    </div>
  )
}

const PeopleAsm = props => (
  <div className={`People-item${props.active ? ' is-active' : ''}`} onClick={props.onClick}>
    <Image src={people01} title="ASM" />
    {props.withTitle && <div className="People-item-title">ASM</div>}
  </div>
)

const PeoplePlus = props => (
  <div className={`People-item${props.active ? ' is-active' : ''}`} onClick={props.onClick}>
    <Image src={people02} title="PLuS" />
    {props.withTitle && <div className="People-item-title">PLuS</div>}
  </div>
)

const PeopleMc = props => (
  <div className={`People-item${props.active ? ' is-active' : ''}`} onClick={props.onClick}>
    <Image src={people03} title="Main Contractors" />
    {props.withTitle && <div className="People-item-title">Main Contractors</div>}
  </div>
)

const PeopleProcurement = props => (
  <div className={`People-item${props.active ? ' is-active' : ''}`} onClick={props.onClick}>
    <Image src={people04} title="Procurement" />
    {props.withTitle && <div className="People-item-title">Procurement</div>}
  </div>
)

export const People = {
  Group: PeopleGroup,
  Asm: PeopleAsm,
  Plus: PeoplePlus,
  Mc: PeopleMc,
  Procurement: PeopleProcurement,
}
